export default __webpack_public_path__ + "c6db07ec6fa4a532524ef6396bd4c1c6.svg";